import { useState, useEffect } from 'react';
import { NextSeo } from 'next-seo';
import Head from 'next/head';

function verifyRedirect() {
  if (typeof window === 'undefined') {
    return null;
  }

  const currentSearch = window.location.search;

  return currentSearch;
}

export default function MasterSaasAndServicesAgreementPage() {
  const [pathURL, setPathURL] = useState(null);

  useEffect(() => {
    const searchInfo = verifyRedirect();
    if (searchInfo) {
      setPathURL(
        `${process.env.SITE_URL}/subscription-and-professional-services-agreement` +
          searchInfo
      );
      window.location.href = pathURL;
    } else {
      window.location.href = `${process.env.SITE_URL}/subscription-and-professional-services-agreement`;
    }
  }, [pathURL]);
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="Subscription, Professional Services Agreement"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Subscription and Professional Services Agreement"
        description="Subscription and Professional Services Agreement at Loadsmart"
        canonical="https://loadsmart.com/subscription-and-professional-services-agreement/"
        openGraph={{
          url: 'https://loadsmart.com/subscription-and-professional-services-agreement/',
        }}
      />
    </>
  );
}
